import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
  <div class = "row">
  <div class = "col-md-4" >
<span class="created-by">
  <div class="row" class="mail"  >
      <i class="fas fa-envelope fa-2x " status="info"></i>
      <a style="padding-top : 0.3rem; padding-left :0.5rem" target="_blank">info&#64;sdbi.in</a>
  </div>
</span>
</div>  
<div class = "col-md-4" >
<span class="created-by">
  <div class="row contain"  >
        <span class="material-icons">phone</span>
        <div style="padding-top : 0.3rem; padding-left :0.5rem" > 9920053700/9372777617 </div>

  </div>
</span>
</div>  
<div class = "col-md-4" >
<div class="socials " >
<a href="https://www.facebook.com/sdbi.official" target="_blank" class="ion ion-social-facebook"></a>
<a href="https://www.instagram.com/sdbiofficial/" target="_blank" class="ion ion-social-instagram"></a>
<a href="https://www.linkedin.com/company/sdbiofficial" target="_blank" class="ion ion-social-linkedin"></a>
<a href="https://www.youtube.com/channel/UCxyDd_poB_6eMHP_vAPnhwA" target="_blank" class="ion ion-social-youtube"></a>
</div>
</div>
</div>
  `,
})
export class FooterComponent {
}
